const MIME_FORMATS = new Map([
  ['audio/mpeg', 'mp3'],
  ['audio/mp3', 'mp3'],
  ['audio/mp4', 'm4a'],
  ['audio/x-m4a', 'm4a'],
  ['audio/aac', 'aac'],
  ['audio/ogg', 'ogg'],
  ['audio/wav', 'wav'],
  ['audio/x-wav', 'wav'],
  ['audio/vnd.wave', 'wav'],
  ['audio/flac', 'flac'],
  ['audio/webm', 'webm']
])

const SUPPORTED_EXTENSIONS = new Set(['mp3', 'm4a', 'mp4', 'aac', 'ogg', 'wav', 'flac', 'webm'])

function extensionFrom(value) {
  if (!value || typeof value !== 'string') return null
  const clean = value.split(/[?#]/, 1)[0]
  const match = clean.match(/\.([a-z0-9]+)$/i)
  if (!match) return null
  const extension = match[1].toLowerCase()
  if (!SUPPORTED_EXTENSIONS.has(extension)) return null
  return extension === 'mp4' ? 'm4a' : extension
}

export function inferAudioFormat({ mimeType, sourceUrl, filename, headerBytes } = {}) {
  const normalizedMime = typeof mimeType === 'string'
    ? mimeType.split(';', 1)[0].trim().toLowerCase()
    : ''
  if (MIME_FORMATS.has(normalizedMime)) return MIME_FORMATS.get(normalizedMime)

  const extension = extensionFrom(sourceUrl) || extensionFrom(filename)
  if (extension) return extension

  const bytes = headerBytes instanceof Uint8Array
    ? headerBytes
    : (headerBytes ? new Uint8Array(headerBytes) : null)
  if (!bytes || bytes.length < 4) return null

  if (bytes[0] === 0x49 && bytes[1] === 0x44 && bytes[2] === 0x33) return 'mp3'
  if (bytes[0] === 0xff && (bytes[1] & 0xe0) === 0xe0) {
    return (bytes[1] & 0x16) === 0x10 ? 'aac' : 'mp3'
  }
  if (String.fromCharCode(...bytes.slice(0, 4)) === 'OggS') return 'ogg'
  if (String.fromCharCode(...bytes.slice(0, 4)) === 'fLaC') return 'flac'
  if (
    bytes.length >= 12 &&
    String.fromCharCode(...bytes.slice(0, 4)) === 'RIFF' &&
    String.fromCharCode(...bytes.slice(8, 12)) === 'WAVE'
  ) return 'wav'
  if (bytes.length >= 8 && String.fromCharCode(...bytes.slice(4, 8)) === 'ftyp') return 'm4a'

  return null
}

export function isLikelyHtmlAudioPayload({ mimeType, headerBytes } = {}) {
  const normalizedMime = typeof mimeType === 'string'
    ? mimeType.split(';', 1)[0].trim().toLowerCase()
    : ''
  if (normalizedMime === 'text/html' || normalizedMime === 'application/xhtml+xml') return true

  const bytes = headerBytes instanceof Uint8Array
    ? headerBytes
    : (headerBytes ? new Uint8Array(headerBytes) : null)
  if (!bytes || bytes.length === 0) return false

  const prefix = new TextDecoder().decode(bytes.slice(0, 128)).trimStart().toLowerCase()
  return prefix.startsWith('<!doctype html') ||
    prefix.startsWith('<html') ||
    prefix.includes('<head>')
}

export async function describeAudioBlob(blob, sourceUrl, filename) {
  const headerBytes = blob?.slice
    ? new Uint8Array(await blob.slice(0, 16).arrayBuffer())
    : null

  return {
    mimeType: blob?.type || null,
    audioFormat: inferAudioFormat({
      mimeType: blob?.type,
      sourceUrl,
      filename,
      headerBytes
    }),
    sourceUrl: sourceUrl || null
  }
}
